import React from 'react'
import { H3 } from '@blueprintjs/core'

const MainTitle = ({ text }) => {
    return (
        <H3 id='result' className='margin-bottom-large margin-top-large text-center'>{text}</H3>
    )
}

export default MainTitle

